import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserDetails, User } from "../models/interfaces";
import { InitialDetails } from "../transformer";

const initialState = {
	loading: false,
	error: false,
	usersData: { tableData: [], copiedData: [] },
	selectedRowKeys: [],
	searchText: "",
	toggle: false,
	errorData: null,
	errorHeaderTitle: "",
	isErrorModalVisible: false,
	disabledFields: false,
	userDetails: InitialDetails,
	openUserModal: false,
	profileData: {
		profile_name: "",
		primary_language: "",
		secondary_language: [],
		isActive: true,
	},
};

const userManagementSlice = createSlice({
	name: "userManagement",
	initialState,
	reducers: {
		setUsersData: (state, action: PayloadAction<any>) => {
			state.usersData = action.payload;
		},
		setSelectedRowKeys: (state, action: PayloadAction<User[]>) => {
			state.selectedRowKeys = action.payload;
		},
		setSearchText: (state, action: PayloadAction<string>) => {
			state.searchText = action.payload;
		},
		setToggle: (state, action: PayloadAction<boolean>) => {
			state.toggle = action.payload;
		},
		setIsErrorModalVisible: (state, action: PayloadAction<boolean>) => {
			state.isErrorModalVisible = action.payload;
		},
		setErrorData: (state, action: PayloadAction<any>) => {
			state.errorData = action.payload;
		},
		setErrorHeaderTitle: (state, action: PayloadAction<any>) => {
			state.errorHeaderTitle = action.payload;
		},
		setDisableFields: (state, action: PayloadAction<boolean>) => {
			state.disabledFields = action.payload;
		},
		setUserDetails: (state, action: PayloadAction<IUserDetails>) => {
			state.userDetails = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setError: (state, action: PayloadAction<boolean>) => {
			state.error = action.payload;
		},
		setOpenUserModal: (state, action: PayloadAction<boolean>) => {
			state.openUserModal = action.payload;
		},
		setNewProfile: (state, action: PayloadAction<any>) => {
			state.profileData = action.payload;
		},
		setUserAccess: (state, action: PayloadAction<{ id: string; enable_access: boolean }>) => {
			const { id, enable_access } = action.payload;
			const update = (u: User) =>
				u.collaborator_id === id ? { ...u, enable_access } : u;
			state.usersData.tableData = state.usersData.tableData.map(update);
			state.usersData.copiedData = state.usersData.copiedData.map(update);
		},
	},
});

export const {
	setUsersData,
	setSelectedRowKeys,
	setSearchText,
	setToggle,
	setIsErrorModalVisible,
	setErrorData,
	setErrorHeaderTitle,
	setDisableFields,
	setUserDetails,
	setLoading,
	setError,
	setOpenUserModal,
	setNewProfile,
	setUserAccess,
} = userManagementSlice.actions;
export default userManagementSlice.reducer;
